module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/noentry/noentry.component.scss
// module id = ./src/app/noentry/noentry.component.scss
// module chunks = main